import React from 'react'
import { Box, Stack, Typography, Breadcrumbs, Link, useMediaQuery, useTheme } from '@mui/material'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import { useAppStore } from '@/store'
import { clearCurrentUser } from '@/db/indexedDB'

import { Copy } from '@/components/UI/Copy'
import { SubHeader } from './SubHeader'
import { useNavigate, useLocation } from 'react-router-dom'
import { isGlobalSection, SECTION_ROOTS } from '../sections'

interface HeaderProps {
  title: string
}

export const Header: React.FC<HeaderProps> = ({ title }) => {
  const { user, setUser } = useAppStore()
  const theme = useTheme()
  const navigate = useNavigate()
  const location = useLocation()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  // A customer stays selected in the store while the agent moves around, so the
  // route decides whether that customer is relevant here. Global sections show
  // no breadcrumb customer and no customer tabs, without clearing the selection
  // the agent would otherwise have to search for again.
  const showCustomerContext = Boolean(user) && !isGlobalSection(location.pathname)

  const handleClickAction = () => {
    const route = SECTION_ROOTS[title] ?? '/app'
    // Only clear the selected customer when navigating back to the customer list
    if (route === '/app') {
      setUser(null)
      clearCurrentUser()
    }
    navigate(route)
  }


  return (
    <>
      <Box sx={{ borderBottom: '1px solid #EAECF0', marginTop: isMobile ? 6 : 0 }}>
        <Stack direction={'row'} alignItems="center" spacing={2} sx={{ p: 2.5 }}>
          <Breadcrumbs
            aria-label="breadcrumb"
            separator={<ChevronRightIcon />}
            sx={{ color: '#D0D5DD' }}
          >
            <Link
              underline="hover"
              color="inherit"
              component="button"
              onClick={handleClickAction}
              sx={{
                '&:hover': {
                  textDecoration: 'none',
                },
              }}
            >
              <Typography variant="body1" component="span">{title}</Typography>
            </Link>
            {showCustomerContext && (
              <Typography variant="body1" component="div">
                <strong style={{ fontWeight: 600 }}>
                  {user?.firstName} {user?.lastName}
                </strong>{' '}
                (ID:{' '}
                <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
                  <Copy value={user?.id ?? 'N/A'} />
                </Box>
                )
              </Typography>
            )}
          </Breadcrumbs>
        </Stack>
      </Box>
      {showCustomerContext && <SubHeader />}
    </>
  )
}
